import { MultiTextFilterDTO } from "@landtechnologies/dtos";

export enum MultiTextFilterMust {
  MATCH_ALL = "MATCH_ALL",
  MATCH_NONE = "MATCH_NONE",
}

export interface IMultiTextFilter extends Omit<MultiTextFilterDTO, "must"> {
  type: "multi-text-search";
  must: MultiTextFilterMust;
}
